<template>
  <transition-group class="coluna-pesquisa" name="list-animation" tag="div">
    <LinhaPesquisa
      style="transition: all 1s"
      v-for="coluna in colunasPesquisa"
      :key="coluna.idUsuarioUnimed"
      @input-check="inputCheck"
      :checkProp="checkProp"
      :informacoesObjeto="coluna"
    />
  </transition-group>
</template>

<script>
import LinhaPesquisa from "./LinhaPesquisa";
export default {
  components: {
    LinhaPesquisa
  },
  props: {
    colunasPesquisa: {
      type: Array,
      default: () => [
        // {
        // "cdUnimed": Number,
        // "email": String,
        // "idUsuarioUnimed": Number,
        // "login": String,
        // "nome": String
        // }
      ]
    },
    idUsuarioUnimedGiu: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      checkProp: []
    };
  },
  mounted() {
    if (this.idUsuarioUnimedGiu !== null) {
      this.inputCheck([this.idUsuarioUnimedGiu]);
    }
  },
  methods: {
    inputCheck(arr) {
      this.checkProp = arr.map(e => e);
      this.$emit("input-check", arr);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./ColunaPesquisa.scss";
</style>
